import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { useApiContext } from 'context/ApiContext';

// @mui material components
import AppBar from "@mui/material/AppBar";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";
import 'leaflet/dist/leaflet.css';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
import TurbineDashboardLayout from "examples/LayoutContainers/DashboardLayout";
import TurbineDashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTableV2";

// Overview page components
import ParkForm from "layouts/mainAdministration/pages/ParkForm";
import ParkTab from "layouts/mainAdministration/pages/ParkTab";
import UserForm from "layouts/mainAdministration/pages/UserForm";
import UserTab from "layouts/mainAdministration/pages/UserTab";

// Material Dashboard 2 React base styles
import breakpoints from "assets/theme/base/breakpoints";

function MainAdministration() {
    const { parksAdm, parkFormInfosAdm, userFormInfosAdm, usersAdm,
        setParkFormInfosAdm, setUserFormInfosAdm, APIRequestType, getAPI } = useApiContext();
    const location = useLocation();

    const [tabsOrientation, setTabsOrientation] = useState("horizontal");
    const [tabValue, setTabValue] = useState(0);

    useEffect(() => {
        getAPI(APIRequestType.GET_USERS);
        getAPI(APIRequestType.GET_PARKS);

        console.log(" 0 0 1   Adm");
    }, []);

    useEffect(() => {
        if (tabValue === 0) { // USERS
            setUserFormInfosAdm({
                selectedUser: null,
                formType: "Tab",
            });
        } else if (tabValue === 1) { // PARKS
            setParkFormInfosAdm({
                selectedPark: null,
                formType: "Tab",
            });
        }
        console.log(" 0 0 2   Adm");
    }, [tabValue]);

    const [userFormType, setUserFormType] = useState("Tab");
    useEffect(() => {
        if (userFormInfosAdm) {
            setUserFormType(userFormInfosAdm.formType);
            if (userFormInfosAdm.formType === "Tab") {
                getAPI(APIRequestType.GET_USERS);
            }
        }
    }, [userFormInfosAdm]);

    const [parkFormType, setParkFormType] = useState("Tab");
    useEffect(() => {
        if (parkFormInfosAdm) {
            setParkFormType(parkFormInfosAdm.formType);
            if (parkFormInfosAdm.formType === "Tab") {
                getAPI(APIRequestType.GET_PARKS);
            }
        }
    }, [parkFormInfosAdm]);

    useEffect(() => {
        // Quand on quitte /administration, on reset le formType
        if (location.pathname !== '/administration') {
            setUserFormInfosAdm({
                selectedUser: null,
                formType: "Tab",
            });
            setParkFormInfosAdm({
                selectedPark: null,
                formType: "Tab",
            });
            console.log("Return Tab, change PAGE!");
        }
    }, [location.pathname]);

    useEffect(() => {
        // A function that sets the orientation state of the tabs.
        function handleTabsOrientation() {
            return window.innerWidth < breakpoints.values.sm
                ? setTabsOrientation("vertical")
                : setTabsOrientation("horizontal");
        }

        /** 
         The event listener that's calling the handleTabsOrientation function when resizing the window.
        */
        window.addEventListener("resize", handleTabsOrientation);

        // Call the handleTabsOrientation function to set the state with the initial value.
        handleTabsOrientation();

        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleTabsOrientation);
    }, [tabsOrientation]);

    const handleSetTabValue = (event, newValue) => setTabValue(newValue);

    return (
        <TurbineDashboardLayout>
            <TurbineDashboardNavbar />
            {/* Tab */}
            <MDBox pt={2} pb={2} sx={{ width: 'auto', display: 'flex', justifyContent: 'flex-start' }}>
                <AppBar position="static" sx={{ width: "250px" }}>
                    <Tabs orientation={tabsOrientation} value={tabValue} onChange={handleSetTabValue} sx={{ backgroundColor: '#d8dadd' }}>
                        <Tab
                            icon={<Icon fontSize="small" sx={{ mt: -0.25 }}> assignment_ind </Icon>}
                            label="USERS"
                        />
                        <Tab
                            icon={<Icon fontSize="small" sx={{ mt: -0.25 }}> pin_drop </Icon>}
                            label="PARKS"
                        />
                    </Tabs>
                </AppBar>
            </MDBox>

            {/* Users Table */}
            {tabValue === 0 && (
                <>
                    {usersAdm.length > 0 ? (
                        userFormType === "Tab" ? (
                            <UserTab users={usersAdm} />

                        ) : userFormType === "CreateUser" ? (
                            <MDBox>
                                <MDBox display="flex" justifyContent="flex-end" mr={3} mt={-4}>
                                    <MDTypography
                                        variant="button"
                                        fontWeight="bold"
                                        color="dark"
                                        fontSize="1.2rem"
                                    >
                                        {"CREATE User"}
                                    </MDTypography>
                                </MDBox>
                                <UserForm />
                            </MDBox>

                        ) : userFormType === "ModifyUser" ? (
                            <MDBox>
                                <MDBox display="flex" justifyContent="flex-end" mr={3} mt={-4}>
                                    <MDTypography
                                        variant="button"
                                        fontWeight="bold"
                                        color="dark"
                                        fontSize="1.2rem"
                                    >
                                        {"MODIFY User"}
                                    </MDTypography>
                                </MDBox>
                                <UserForm />
                            </MDBox>

                        ) : userFormType === "VisualizeUser" ? (
                            <MDBox>
                                <MDBox display="flex" justifyContent="flex-end" mr={3} mt={-4}>
                                    <MDTypography
                                        variant="button"
                                        fontWeight="bold"
                                        color="dark"
                                        fontSize="1.2rem"
                                    >
                                        {"VISUALIZE User"}
                                    </MDTypography>
                                </MDBox>
                                <UserForm />
                            </MDBox>
                        ) : null
                    ) : (
                        userFormType === "Tab" && (
                            <MDBox display="flex" alignItems="center" justifyContent="center">
                                <MDTypography
                                    variant="button"
                                    fontWeight="bold"
                                    color="secondary"
                                    opacity={0.4}
                                    ml={1}
                                    fontSize="5rem"
                                >
                                    No User
                                </MDTypography>
                            </MDBox>
                        )
                    )}
                </>
            )}

            {/* Parks Table */}
            {tabValue === 1 && (
                parkFormType === "Tab" ? (
                    <ParkTab parks={parksAdm} />

                ) : parkFormType === "CreatePark" ? (
                    <MDBox>
                        <MDBox display="flex" justifyContent="flex-end" mr={3}>
                            <MDTypography
                                variant="button"
                                fontWeight="bold"
                                color="dark"
                                fontSize="1.2rem"
                            >
                                {"CREATE Park"}
                            </MDTypography>
                        </MDBox>
                        <ParkForm />
                    </MDBox>

                ) : parkFormType === "ModifyPark" ? (
                    <MDBox>
                        <MDBox display="flex" justifyContent="flex-end" mr={3}>
                            <MDTypography
                                variant="button"
                                fontWeight="bold"
                                color="dark"
                                fontSize="1.2rem"
                            >
                                {"MODIFY Park"}
                            </MDTypography>
                        </MDBox>
                        <ParkForm />
                    </MDBox>

                ) : parkFormType === "VisualizePark" ? (
                    <MDBox>
                        <MDBox display="flex" justifyContent="flex-end" mr={3}>
                            <MDTypography
                                variant="button"
                                fontWeight="bold"
                                color="dark"
                                fontSize="1.2rem"
                            >
                                {"VISUALIZE Park"}
                            </MDTypography>
                        </MDBox>
                        <ParkForm />
                    </MDBox>
                ) : null
            )}
        </TurbineDashboardLayout >
    );
}

export default MainAdministration;